import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
    cached: {},
}

export const getters = {}

export const mutations = {
    STORES(state, stores) {
        state.cached = stores
    },
}

export const actions = {

    init({ state, dispatch }) { },

    fetchStores(context, query) {
        query = query || ''
        return axios.get(`${serverUrl}/app/stores/${query}`).then((response) => {
            const request = response.data
            context.commit('STORES', response.data.results)
            return request
        })
    },

    // fetchParticipantsOptions(context, query) {
    //     query = query || ''
    //     return axios.get(`${serverUrl}/api/masters/participants/options/${query}`).then((response) => {
    //         return response.data
    //     })
    // },

    // fetchParticipantsDetail(context, id) {
    //     return axios.get(`${serverUrl}/api/masters/participants/${id}/`).then((response) => {
    //         return response.data
    //     })
    // },

    // fetchParticipantByIdentification(context, identification) {
    //     return axios.get(`${serverUrl}/api/masters/participants/get_by_identification/?identification=${identification}`).then((response) => {
    //         return response.data
    //     })
    // },

    createUpdateStores(context, formData) {
        let promise = null
        if (formData._id) {
            promise = axios.put(`${serverUrl}/app/stores/${formData._id}/`, formData)
        } else {
            promise = axios.post(`${serverUrl}/app/stores`, formData)
        }
        return promise.then(
            (response) => {
                return response.data
            }
        )
    },

    deleteStores(context, _id) {
        let promise = null
        promise = axios.delete(`${serverUrl}/app/stores/${_id}`)
        return promise.then(
            (response) => {
                return response.data
            }
        )
    },



}